import { action } from 'typesafe-actions';

import { DbdsTypes, DbdInterface, DbdVersionListInterface } from './types';

// List Dbds
export const listDbdsRequest = (payload: any) =>
  action(DbdsTypes.LIST_DBDS_REQUEST, payload);
export const listDbdsSuccess = (payload: { dbdsList: DbdInterface[] }) =>
  action(DbdsTypes.LIST_DBDS_SUCCESS, payload);
export const listDbdsFailure = () => action(DbdsTypes.LIST_DBDS_FAILURE);

// Get Dbd
export const getDbdRequest = (payload: any) =>
  action(DbdsTypes.GET_DBD_REQUEST, payload);
export const getDbdSuccess = (payload: { dbdData: DbdInterface }) =>
  action(DbdsTypes.GET_DBD_SUCCESS, payload);
export const getDbdFailure = () => action(DbdsTypes.GET_DBD_FAILURE);

// Create Dbd
export const createDbdRequest = (payload: object) =>
  action(DbdsTypes.CREATE_DBD_REQUEST, payload);
export const createDbdSuccess = (payload: { dbdData: DbdInterface }) =>
  action(DbdsTypes.CREATE_DBD_SUCCESS, payload);
export const createDbdFailure = () => action(DbdsTypes.CREATE_DBD_FAILURE);

// Update Dbd
export const updateDbdRequest = (payload: object) =>
  action(DbdsTypes.UPDATE_DBD_REQUEST, payload);
export const updateDbdSuccess = (payload: { dbdData: DbdInterface }) =>
  action(DbdsTypes.UPDATE_DBD_SUCCESS, payload);
export const updateDbdFailure = () => action(DbdsTypes.UPDATE_DBD_FAILURE);

// Delete Dbd
export const deleteDbdRequest = (payload: object) =>
  action(DbdsTypes.DELETE_DBD_REQUEST, payload);
export const deleteDbdSuccess = () => action(DbdsTypes.DELETE_DBD_SUCCESS);
export const deleteDbdFailure = () => action(DbdsTypes.DELETE_DBD_FAILURE);

// Request Status
export const requestStatusRequest = (payload: object) =>
  action(DbdsTypes.REQUEST_STATUS_REQUEST, payload);
export const requestStatusSuccess = () =>
  action(DbdsTypes.REQUEST_STATUS_SUCCESS);
export const requestStatusFailure = () =>
  action(DbdsTypes.REQUEST_STATUS_FAILURE);

// Get Dbd Version List
export const getDbdVersionListRequest = (payload: any) =>
  action(DbdsTypes.GET_DBD_VERSION_LIST_REQUEST, payload);
export const getDbdVersionListSuccess = (payload: {
  dbdVersionList: Array<DbdVersionListInterface>;
}) => action(DbdsTypes.GET_DBD_VERSION_LIST_SUCCESS, payload);
export const getDbdVersionListFailure = () =>
  action(DbdsTypes.GET_DBD_VERSION_LIST_FAILURE);

// Get Dbd Version Data
export const getDbdVersionDataRequest = (payload: any) =>
  action(DbdsTypes.GET_DBD_VERSION_REQUEST, payload);
export const getDbdVersionDataSuccess = (payload: {
  dbdVersionData: DbdVersionListInterface;
}) => action(DbdsTypes.GET_DBD_VERSION_SUCCESS, payload);
export const getDbdVersionDataFailure = () =>
  action(DbdsTypes.GET_DBD_VERSION_FAILURE);

// Get Dbd Version Data
export const dbdVersionRequestListRequest = (payload: object) =>
  action(DbdsTypes.DBD_VERSION_REQUEST_LIST_REQUEST, payload);
export const dbdVersionRequestListSuccess = (payload: {
  dbdVersionRequestList: DbdVersionListInterface;
}) => action(DbdsTypes.DBD_VERSION_REQUEST_LIST_SUCCESS, payload);
export const dbdVersionRequestListFailure = () =>
  action(DbdsTypes.DBD_VERSION_REQUEST_LIST_FAILURE);

// Version Update Request
export const versionUpdateRequest = (payload: {
  dbdVersionId: string;
  dbdIds: Array<string>;
  type: 'update' | 'downgrade';
}) => action(DbdsTypes.VERSION_UPDATE_REQUEST_REQUEST, payload);
export const versionUpdateSuccess = () =>
  action(DbdsTypes.VERSION_UPDATE_REQUEST_SUCCESS);
export const versionUpdateFailure = () =>
  action(DbdsTypes.VERSION_UPDATE_REQUEST_FAILURE);

// Create Many Dbd
export const createManyDbdRequest = (payload: Array<object>) =>
  action(DbdsTypes.CREATE_MANY_DBD_REQUEST, payload);
export const createManyDbdSuccess = (payload: { dbdsList: DbdInterface[] }) =>
  action(DbdsTypes.CREATE_MANY_DBD_SUCCESS, payload);
export const createManyDbdFailure = () =>
  action(DbdsTypes.CREATE_MANY_DBD_FAILURE);
